import { useTranslation } from 'react-i18next'
import { TicketIcon } from 'src/components/Membership/MembershipIcon'
import { CouponCountDown } from './CouponCountDown'
import {
  useAvailableCouponCount,
  useOpenCouponListDialog,
  useSelectedCouponInfo,
} from './states'

export function CouponButton() {
  const { t } = useTranslation(['membership'])
  const openCouponListDialog = useOpenCouponListDialog()
  const selectedCoupon = useSelectedCouponInfo()
  const { count: couponCount, isLoading } = useAvailableCouponCount()

  // Hide button if no coupons and not loading
  if (couponCount === 0 && !isLoading) {
    return null
  }

  // Hide button during initial load (no data yet)
  if (couponCount === 0 && isLoading) {
    return null
  }

  return (
    <div className="col-span-full flex justify-center mb-4">
      <div className="w-full flex flex-col items-center gap-2 md:grid md:grid-cols-[1fr_auto_1fr]">
        {/* Empty left spacer for symmetry - hidden on mobile */}
        <div className="hidden md:block" />
        {/* Button always centered */}
        <button
          onClick={openCouponListDialog}
          className="flex items-center gap-1.5 bg-white dark:bg-neutral-800 border rounded-full py-1.5 px-1.5 transition-all group border-purple-200 dark:border-purple-800 shadow-sm hover:shadow-md hover:border-purple-300 dark:hover:border-purple-600"
        >
          <div className="bg-purple-100 dark:bg-purple-900/50 p-1.5 rounded-full text-purple-600 dark:text-purple-400">
            <TicketIcon className="size-4" />
          </div>

          <div className="flex items-center text-sm">
            {selectedCoupon ? (
              <div className="font-bold text-purple-700 dark:text-purple-400 flex items-center gap-1">
                <span className="px-1">{t(selectedCoupon.template.name)}</span>
                <span className="bg-purple-600 text-white text-xs px-2 py-0.5 rounded-full">
                  +{selectedCoupon.boostRatePercentage}%
                </span>
                <CouponCountDown coupon={selectedCoupon} />
              </div>
            ) : (
              <span className="text-neutral-400 dark:text-neutral-500 font-normal pr-3">
                {t('membership:extra-pack.coupon-list.select', 'Select')}
              </span>
            )}
          </div>
        </button>
      </div>
    </div>
  )
}
